import { Injectable } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CreditDocsCommand extends BaseProductCommand {
  readonly type = 'docs';
  readonly title = 'Документы';
  readonly icon = 'doc';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.CREDIT]: 10         // Кредит: Документы (1-й в списке "прочее")
    }, 999);
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/credit-docs/${context.data.contractId}`);
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): Observable<boolean> | boolean {
    return !!context.data.contractId;
  }
}
